import { useEffect } from 'react';

export function useMetadata(title, description, image) {
  useEffect(() => {
    // Sæt sprog til dansk
    document.documentElement.lang = 'da';

    // 1. Sæt sidetitel
    if (title) {
      document.title = title;
    }

    // Standardværdier
    const defaultImage = 'https://assets.auxodev.dk/assets/ecc7c3d2-b2a3-4a1d-ba29-5687874f0c20/logo.jpg';
    const finalImage = image || defaultImage;
    const currentUrl = window.location.href;

    // Funktion til at oprette eller opdatere meta-tags
    const setMetaTag = (attrName, attrValue, content) => {
      if (!content) return;
      let element = document.querySelector(`meta[${attrName}="${attrValue}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attrName, attrValue);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    // Standard SEO Meta Tags
    if (description) {
      setMetaTag('name', 'description', description);
    }
    setMetaTag('name', 'robots', 'index, follow');

    // Open Graph / Facebook Meta Tags
    if (title) {
      setMetaTag('property', 'og:title', title);
    }
    if (description) {
      setMetaTag('property', 'og:description', description);
    }
    setMetaTag('property', 'og:image', finalImage);
    setMetaTag('property', 'og:url', currentUrl);
    setMetaTag('property', 'og:type', 'website');
    setMetaTag('property', 'og:site_name', 'FLOW Transport & Logistik ApS');

    // Twitter Meta Tags
    setMetaTag('name', 'twitter:card', 'summary_large_image');
    if (title) {
      setMetaTag('name', 'twitter:title', title);
    }
    if (description) {
      setMetaTag('name', 'twitter:description', description);
    }
    setMetaTag('name', 'twitter:image', finalImage);

    // Canonical Link Tag
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', currentUrl);

  }, [title, description, image]);
}
